import './FacilityInquiryTabs.less'
import { Button, Descriptions, Form, Input, message } from 'antd'
import type { DescriptionsProps } from 'antd'
import { useEffect, useState } from 'react'
import DialogBox from '@/components/Content/DialogBox'
import {
  // IAjaxLogin,
  IDeleteQna, IGetFcltDetail,
  IGetLoginUser,
  IGetQnaList, IInsertAnswer, IInsertQna, IUpdateAnswer, IUpdateQna,
} from '@/service/rightNavCtrl'
import useStore from '@/hooks/useStore'

const { TextArea } = Input

const TABLE_ITEM: DescriptionsProps['items'] = [
  {
    key: '1',
    label: '소속',
    children: '',
    span: 4,
  },
  {
    key: '2',
    label: '연락처',
    children: '',
    span: 4,
  },
]

const BTN1 = '답변등록'
const BTN2 = '답변수정'
const BTN3 = '삭제'
const BTN4 = '수정'

const EnumUserSeCode = {
  manager: '3',
  user: '7',
  salesman: '10',
}

function FacilityInquiryTabs() {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const facilityStore = useStore('facilityStore')
  const { idlFcltUnqNo } = facilityStore
  const [popupOpen, setPopupOpen] = useState(false)
  const [correctionPopOpen, setCorrectionPopOpen] = useState(false)
  const [belongPopOpen, setBelongPopOpen] = useState(false)
  const [inquiryPopOpen, setInquiryPopOpen] = useState(false)
  const [tableItem, setTableItem] = useState<DescriptionsProps['items']>(TABLE_ITEM)
  const [qaData, setQaData] = useState<any>([])
  const [textValue, setTextValue] = useState<string>('')
  const [answerValue, setAnswerValue] = useState<string>('')
  const [answerUpdateValue, setAnswerUpdateValue] = useState<string>('')
  const [btn4Value, setBtn4Value] = useState<string>('')
  const [btn1Item, setBtn1Item] = useState<any>(null)
  const [btn2Item, setBtn2Item] = useState<any>(null)
  const [btn3Item, setBtn3Item] = useState<any>(null)
  const [btn4Item, setBtn4Item] = useState<any>(null)
  const [messageApi, contextHolder] = message.useMessage()
  const [showAnswerBtn, setShowAnswerBtn] = useState(false)
  const [loginUserInfo, setLoginUserInfo] = useState<any>(null)

  useEffect(() => {
    if (idlFcltUnqNo) {
      getFcltDetail(idlFcltUnqNo)
      getQaData(idlFcltUnqNo)
    }
  }, [idlFcltUnqNo])

  const init = () => {
    const id = localStorage.getItem('JSESSIONID') || ''
    const obj = {
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    IGetLoginUser(obj)
      .then((res: any) => {
        if (res.code === 200) {
          if (res.result && res.result.userSeCode === EnumUserSeCode.salesman) {
            setShowAnswerBtn(true)
          }
          if (res.result && res.result.userId) {
            setLoginUserInfo(res.result.userId)
          }
        }
      })
  }

  const getFcltDetail = (str: string) => {
    const id = localStorage.getItem('JSESSIONID') || ''
    const obj = {
      idlFcltUnqNo: str,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    IGetFcltDetail(obj).then((res: any) => {
      if (res.code === 200) {
        const { result = {} } = res
        const arr = JSON.parse(JSON.stringify(tableItem))
        arr[0].children = result.picOgdpNm
        arr[1].children = result.picCttpc
        setTableItem(arr)
      }
    })
  }

  const getQaData = async (str: string | null) => {
    if (!str)
      return
    const obj = {
      idlFcltUnqNo: str,
      pageIndex: 1,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    IGetQnaList(obj).then((res: any) => {
      if (res.code === 200) {
        const { result = {} } = res
        setQaData(result.resultList || [])
        init()
      }
    })
  }

  const button1Click = (item: any) => {
    setPopupOpen(true)
    setBtn1Item(item)
  }

  const button1ModalClick = (flag: boolean) => {
    setPopupOpen(!popupOpen)
    if (flag) {
      const id = localStorage.getItem('JSESSIONID') || ''
      const obj = {
        apiKey: window.SystemConfig.facilityApiKey,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        rntDlngQnaUnqNo: btn1Item && btn1Item.rntDlngQnaUnqNo,
        ansCn: answerValue,
      }
      IInsertAnswer(obj).then((res: any) => {
        if (res.code === 200) {
          getQaData(idlFcltUnqNo)
        }
      })
    }
  }

  const button2Click = (item: any) => {
    setCorrectionPopOpen(true)
    setBtn2Item(item)
    setAnswerUpdateValue(item.ansCn)
  }

  const button2ModalClick = (flag: boolean) => {
    setCorrectionPopOpen(!correctionPopOpen)
    if (flag) {
      const id = localStorage.getItem('JSESSIONID') || ''
      const obj = {
        apiKey: window.SystemConfig.facilityApiKey,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        rntDlngQnaUnqNo: btn2Item && btn2Item.rntDlngQnaUnqNo,
        ansCn: answerUpdateValue,
      }
      IUpdateAnswer(obj).then((res: any) => {
        if (res.code === 200) {
          getQaData(idlFcltUnqNo)
        }
      })
    }
  }

  const button3Click = (item: any) => {
    setBelongPopOpen(true)
    setBtn3Item(item)
  }

  const button3ModalClick = (flag: boolean) => {
    setBelongPopOpen(!belongPopOpen)
    if (flag) {
      const id = localStorage.getItem('JSESSIONID') || ''
      const obj = {
        apiKey: window.SystemConfig.facilityApiKey,
        rntDlngQnaUnqNo: btn3Item && btn3Item.rntDlngQnaUnqNo,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      }
      IDeleteQna(obj).then((res: any) => {
        if (res.code === 200) {
          getQaData(idlFcltUnqNo)
        }
      })
    }
  }

  const button4Click = (item: any) => {
    setBtn4Value(item.qstnCn)
    setInquiryPopOpen(true)
    setBtn4Item(item)
  }

  const button4ModalClick = (flag: boolean) => {
    setInquiryPopOpen(!inquiryPopOpen)
    if (flag) {
      const id = localStorage.getItem('JSESSIONID') || ''
      const obj = {
        apiKey: window.SystemConfig.facilityApiKey,
        rntDlngQnaUnqNo: btn4Item && btn4Item.rntDlngQnaUnqNo,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        qstnCn: btn4Value,
      }
      IUpdateQna(obj).then((res: any) => {
        if (res.code === 200) {
          getQaData(idlFcltUnqNo)
        }
      })
    }
  }

  const handleAddQuestion = () => {
    const id = localStorage.getItem('JSESSIONID') || ''
    if (!textValue)
      return
    const obj = {
      apiKey: window.SystemConfig.facilityApiKey,
      idlFcltUnqNo,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      qstnCn: textValue,
    }
    IInsertQna(obj).then((res: any) => {
      if (res.code === 200) {
        getQaData(idlFcltUnqNo)
      }
    })
      .catch((err: any) => {
        console.log(err)
      })
  }

  return (
    <>
    {contextHolder}
    <div className={'FacilityInquiryTabs'}>
      <div className={'tablePart'}>
        <Descriptions title="담당자 정보" size={'small'} bordered items={tableItem} />
      </div>
      <div className={'question-inner'}>
        <strong>문의하기</strong>
        <ul className={'question-list'}>
          {qaData.map((item: any, index: number) => {
            return (
              <li className={'question-item'} key={index}>
                <span className={'id-name'}>
                  {item.rgtrId}({item.rgtrNm})
                </span>
                <p className={'question-txt'}>{item.qstnCn}</p>
                <p className={'normal'}>{item.ansCn && item.ansCn}</p>
                <div className={'btn-wrap'}>
                  {!item.ansCn && showAnswerBtn && (
                    <Button onClick={() => button1Click(item)} className={'button1'}>
                      {BTN1}
                    </Button>
                  )}
                  {item.ansCn && showAnswerBtn && (
                    <Button onClick={() => button2Click(item)} className={'button2'}>
                      {BTN2}
                    </Button>
                  )}
                  {
                  !item.ansCn && item.rgtrId === loginUserInfo && (
                    <Button onClick={() => button3Click(item)} className={'button3'}>
                      {BTN3}
                    </Button>
                  )}
                  {
                    item.rgtrId === loginUserInfo
                    && (
                      <Button onClick={() => button4Click(item)} className={'button4'}>
                    {BTN4}
                  </Button>
                    )
                  }

                </div>
              </li>
            )
          })}
          <li className={'question-item'}>
            <TextArea
              value={textValue}
              onChange={(e) => {
                setTextValue(e.target.value)
              }}
              className={'textarea'}
              placeholder="내용을 입력해주세요.(최대 200자)"
              maxLength={200}
            />
            <div className={'btn-wrap'}>
              <Button onClick={handleAddQuestion} className={'button5'}>
                문의하기
              </Button>
            </div>
          </li>
        </ul>
      </div>

      <div className={'FacilityInquiryTabs'}>
        <DialogBox
          close={() => {
            setPopupOpen(false)
          }}
          width={1000}
          title={BTN1}
          open={popupOpen}
        >
          <Form>
            <Form.Item>
              <strong>질문</strong>
              <TextArea disabled value={btn1Item && btn1Item.qstnCn} className={'DialogBox-TextArea1'} />
              <div style={{ fontSize: 12 }}>
                {btn1Item && `${btn1Item.rgtrId}(${btn1Item.rgtrNm})`}
              </div>
            </Form.Item>
            <Form.Item>
              <strong>답변</strong>
              <TextArea
                value={answerValue}
                onChange={(e) => {
                  setAnswerValue(e.target.value)
                }}
                className={'DialogBox-TextArea2'}
                placeholder={'내용을 입력해주세요.(최대 200자)'}
                maxLength={200}
              />
              <div style={{ fontSize: 12 }}>{btn1Item && `${btn1Item.answrId}(${btn1Item.answrNm})`}</div>
            </Form.Item>
            <Form.Item>
              <div className={'btn-wrap'}>
                <Button htmlType="submit" onClick={() => button1ModalClick(true)} className={'btn-check'}>
                  등록
                </Button>
                <Button htmlType="button" onClick={() => button1ModalClick(false)} className={'btn-cancel'}>
                  취소
                </Button>
              </div>
            </Form.Item>
          </Form>
        </DialogBox>

        <DialogBox
          close={() => {
            setCorrectionPopOpen(false)
          }}
          width={1000}
          title={BTN2}
          open={correctionPopOpen}
        >
          <Form>
            <Form.Item>
              <strong>질문</strong>
              <TextArea disabled value={btn2Item && btn2Item.qstnCn} className={'DialogBox-TextArea1'} />
              <div style={{ fontSize: 12 }}>{btn2Item && `${btn2Item.rgtrId}(${btn2Item.rgtrNm})`}</div>
            </Form.Item>
            <Form.Item>
              <strong>답변</strong>
              <TextArea
                value={answerUpdateValue}
                onChange={(e) => {
                  setAnswerUpdateValue(e.target.value)
                }}
                className={'DialogBox-TextArea2'}
              />
            </Form.Item>
            <Form.Item>
              <div className={'btn-wrap'}>
                <Button htmlType="submit" onClick={() => button2ModalClick(true)} className={'btn-check'}>
                  수정
                </Button>
                <Button htmlType="button" onClick={() => button2ModalClick(false)} className={'btn-cancel'}>
                  취소
                </Button>
              </div>
            </Form.Item>
          </Form>
        </DialogBox>

        <DialogBox
          close={() => {
            setBelongPopOpen(false)
          }}
          width={480}
          open={belongPopOpen}
        >
          <Form>
            <Form.Item>
              <div className={'WarningPop'}>
                <p className={'pop-warning'}></p>
                <div className={'popup-info'}>문의하신 내용을 삭제하시겠습니까?</div>
              </div>
            </Form.Item>
            <Form.Item>
              <div className={'btn-wrap'}>
                <Button htmlType="submit" onClick={() => button3ModalClick(true)} className={'btn-check'}>
                  삭제
                </Button>
                <Button htmlType="button" onClick={() => button3ModalClick(false)} className={'btn-cancel'}>
                  취소
                </Button>
              </div>
            </Form.Item>
          </Form>
        </DialogBox>

        <DialogBox
          close={() => {
            setInquiryPopOpen(false)
          }}
          width={1000}
          title={'문의수정'}
          open={inquiryPopOpen}
        >
          <Form>
            <Form.Item>
              <strong>질문</strong>
              <TextArea
                value={btn4Value}
                onChange={(e) => {
                  setBtn4Value(e.target.value)
                }}
                className={'DialogBox-TextArea1'}
              />
            </Form.Item>
            <Form.Item>
              <div className={'btn-wrap'}>
                <Button htmlType="submit" onClick={() => button4ModalClick(true)} className={'btn-check'}>
                  수정
                </Button>
                <Button htmlType="button" onClick={() => button4ModalClick(false)} className={'btn-cancel'}>
                  취소
                </Button>
              </div>
            </Form.Item>
          </Form>
        </DialogBox>
      </div>
    </div>
    </>
  )
}

export default FacilityInquiryTabs
